import viewportEvents, { Viewport } from '@/core/responsive/viewport/viewportEvents.service';

interface WrapperAndTable {
    containingElement: HTMLElement,
    wrapper: HTMLElement,
    table: HTMLElement
}

let oldWidthNHeight = 0;

const wrappersAndTables = new Set<WrapperAndTable>();

function toggleHorisontalScroll(table: HTMLElement, wrapper: HTMLElement) {
    if (table.clientWidth > wrapper.clientWidth) {
        wrapper.classList.add('has-scroll');
    } else {
        wrapper.classList.remove('has-scroll');
    }
}

function viewPortChangeEventHandler(viewport: Viewport) {
    const newWidthNHeight = viewport.width + viewport.height;
    if (newWidthNHeight === oldWidthNHeight) return;
    oldWidthNHeight = newWidthNHeight;

    wrappersAndTables.forEach(x => {
        toggleHorisontalScroll(x.table, x.wrapper);
    });
}

function registerTableOverflow(containingElement: HTMLElement) {
    if (!containingElement) throw new Error('containingElement must not be undefined!');
    const wrappers = containingElement.querySelectorAll('.scrollable') as NodeListOf<HTMLElement>;
    if (wrappersAndTables.size === 0) {
        viewportEvents.setCallback(viewPortChangeEventHandler);
    }
    wrappers.forEach(wrapper => {
        const table = wrapper.querySelector('table') as HTMLTableElement;
        if (table) {
            wrappersAndTables.add({
                containingElement,
                wrapper,
                table
            });
            toggleHorisontalScroll(table, wrapper);
        }
    });
}

function unregisterTableOverflow(containingElement: HTMLElement) {
    if (!containingElement) throw new Error('containingElement must not be undefined!');
    const countBefore = wrappersAndTables.size;
    wrappersAndTables.forEach(x => {
        if (x.containingElement === containingElement) {
            wrappersAndTables.delete(x);
        }
    });
    if (countBefore > 0 && wrappersAndTables.size === 0) {
        viewportEvents.removeCallback(viewPortChangeEventHandler);
    }
}

function wrapTableInOuterDivs(html: string): string {
    function replaceFunc(...params: string[]): string {
        return `<div class="scrollable"><div>${params[0]}</div></div>`;
    }

    const replaceEx = /(<table[^>]*>[^]*?<\/table>)/ig;

    return html.replace(replaceEx, replaceFunc);
}

export default {
    registerTableOverflow,
    unregisterTableOverflow,
    wrapTableInOuterDivs
};
